import { PublicKey } from '@solana/web3.js'
import Decimal from 'decimal.js'
import { u128ToDecimal } from '../utils/HedgeConstants'

export class StakingPool {
  public publicKey: PublicKey

  public halfLifeInDays: number
  public deposits: number
  public startTime: number
  public lastTransactionTime: number
  public hedgeRewardAccumulator: Decimal
  public ushFeeAccumulator: Decimal
  public totalHedgeReward: number
  public stakedTokenMint: PublicKey
  // public seedPhrase: number
  public collateralFeeAccumulator: Decimal[]
  // public bump: number

  constructor(
    poolData: any,
    key: PublicKey,
  ) {

    this.publicKey = key

    this.halfLifeInDays = poolData.halfLifeInDays.toNumber()
    this.deposits = poolData.deposits.toNumber()
    this.startTime = poolData.startTime.toNumber()
    this.lastTransactionTime = poolData.lastTransactionTime.toNumber()
    this.hedgeRewardAccumulator = u128ToDecimal(
      poolData.hedgeRewardAccumulator
    )
    this.ushFeeAccumulator = u128ToDecimal(
      poolData.ushFeeAccumulator
    )
    this.stakedTokenMint = poolData.stakedTokenMint

    this.collateralFeeAccumulator = poolData.collateralFeeAccumulator.map(
      (accum: any) => {
        return u128ToDecimal(accum)
      }
    )
  }
}

